enum ThemeBreakpointIndexEnum {
	small = 0,
	medium = 1,
	large = 2,
	xlarge = 3,
	xxlarge = 4 // Kiosk size
}

export default ThemeBreakpointIndexEnum;
